import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ApiResponse } from 'modules/auth/interfaces/apiResponse';
import { ClientsSourceResponse } from '@/modules/clientslist/models/ClientsSourceResponse';
import { ClientsSourceRequest } from '@/modules/clientslist/models/ClientsSourceRequest';
import { DataSource } from '@/modules/clientslist/interfaces/DataSource';

export class ClientsListApi {
  public async fetch(
    request: ClientsSourceRequest,
    actingBrokerId?: number | null,
  ): Promise<ClientsSourceResponse> {
    let config: AxiosRequestConfig = {};

    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id' : actingBrokerId,
        },
      };
    }

    const response: any = await AuthorizedApiClient.post(
      '/client/list-by-mortgage',
      request,
      config,
    );

    const data = response.data.data;
    return data;
  }
}
